import React from "react";
import { DashBoardContextProvider } from "./DashBoardView";
import DashBoard from "../DashBoard/views/DashBoard";

const DashBoardPage = () => {
  return (
    <div>
      <DashBoardContextProvider>
        <DashBoard />
      </DashBoardContextProvider>
    </div>
  );
};

export default DashBoardPage;
